import gql from 'graphql-tag';

export const GuestsOfGuestsQuery = gql`
    query getTravelerStayQuery($conversationId: String!) {
        getTravelerStay(conversationId: $conversationId) {
            booking {
                isPrimaryGuest
                guests {
                    adults
                    children
                }
                periodOfStay {
                    checkInDate
                    checkOutDate
                }
                uuid
            }
            stayGuestOfGuests {
                acceptedInvite
                email
                firstName
                fullName
                isPrimary
                lastName
            }
        }
    }
`;
